import React from "react";

export default function Message(props) {
    return (
        <div>
        Upload your logo and pictures of your clinic.
        <br/>
        <br/>
        <h6> Pictures of your clinic will make it easier for potential customers to see themselves going to your practise.
            <br/>
            <br/>
            Our simple service makes it easier for you to add pictures of your clinic - all around the clock. 
            Add your images of your clinic today so that we can start showing it to customers.
            <br/>
            <br/>
            Welcome to AUE.dentist!
        </h6>
        </div>

    )
}